/**
 * localStorage keys + the new-day rule for the chatbot subsystem.
 *
 * Lives in a dependency-free module (localStorage + Date only) so the composition root and the
 * Conversation-slice lifecycle-reset hook share the SAME key names and the SAME definition of
 * "a new day" without importing each other.
 */

export const LAST_ACTIVE_DATE_KEY = 'tangerine_chatbot_last_active_date';

export const CHATBOT_UI_STATE_KEY = 'tangerine_chatbot_ui_state';

/**
 * Whether a new calendar day has started since the last stamped activity. A missing stamp (first
 * visit) is NOT a new day: the reset semantics only apply to returning sessions.
 */
export function isNewDaySinceLastActive(): boolean {
  const lastActiveDate = localStorage.getItem(LAST_ACTIVE_DATE_KEY);
  return lastActiveDate !== null && lastActiveDate !== new Date().toDateString();
}

export function stampActiveDay(): void {
  localStorage.setItem(LAST_ACTIVE_DATE_KEY, new Date().toDateString());
}
